import React, { useEffect, useRef, useState } from "react";
import Select from "react-select"; // ✅ import react-select
import { FiSearch } from "react-icons/fi";
import "../../styles/dynamictable.css";
import { useNavigate } from "react-router-dom";
import SelectDropdown from "./SelectDropdown";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DynamicTable = ({
  columns,
  data,
  filters,
  search,
  setSearch,
  selectedFilters,
  handleFilterChange,
  selectedRows,
  setSelectedRows,
  activeTab,
  onSearchClick,
}) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [search, selectedFilters]);

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRows(data.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };
  const isAllSelected = data.length > 0 && selectedRows.length === data.length;
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && search !== "") {
      const length = search.length;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(length, length);
    }
  }, [search]);

  useEffect(() => {
    if (inputRef.current && search) {
      const length = search.length;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(length, length);
    }
  }, []);
  const [page, setPage] = useState(1);

  return (
    <div className="table-wrapper">
      <div className="filter-bar">
        {/* <div className="search-box">
          <input
            placeholder="Search"
            className="search-box-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <FiSearch />

        </div> */}
        <div 
          className="search-box"
          onClick={() => inputRef.current?.focus()}
          style={{ cursor: "text" }}
        >
          <input
            ref={inputRef}
            placeholder="Search"
            className="search-box-input"
            style={{ flex: 1 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button className="search-btn" onClick={onSearchClick}>
            <FiSearch />
          </button>
        </div>

        <div className="filtersdiv">

          {filters.map((filter) => (
            <div key={filter.key} className="filter-select-wrapper">
              <Select
                placeholder={filter.label}
                options={filter.options}
                value={selectedFilters[filter.key]}
                onChange={(option) => handleFilterChange(filter.key, option)}
                isClearable
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          ))}
        </div>
      </div>
      {data.length > 0 ? (
        <table className="data-table">
          <thead>
            <tr>
              <th>S no</th>
              {columns.map((col) => (
                <th key={col.key}>
                  {col.key === "select" ? (
                    <label
                      className="custom-checkbox"
                      style={{
                        // width: "90%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                          activeTab === "Pending" ? "center" : "flex-start",
                        gap: "10px",
                      }}
                    >
                      {activeTab === "Pending" && <span>Select All</span>}
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                      <span
                        className="checkmark"
                        style={{ marginBottom: "5px" }}
                      ></span>
                      {activeTab !== "Pending" && (
                        <span style={{}}>Select All</span>
                      )}
                    </label>
                  ) : (
                    col.label
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={row.id} style={{ cursor: "pointer" }}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render ? col.render(row, index) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={columns.length + 1} style={{ textAlign: "right" }}>
                {totalPages > 1 && (
                  <div className="approvalpagination">
                    {/* ◀ Prev */}
                    {currentPage > 1 && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage((p) => p - 1)}
                      >
                        ‹
                      </button>
                    )}

                    {/* First page */}
                    {currentPage > 1 && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </button>
                    )}

                    {/* Left dots */}
                    {currentPage > 2 && <span className="page-dots">…</span>}

                    {/* Current page */}
                    <button className="page-btn active">{currentPage}</button>

                    {/* Right dots */}
                    {currentPage < totalPages - 1 && (
                      <span className="page-dots">…</span>
                    )}

                    {/* Last page */}
                    {currentPage !== totalPages && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </button>
                    )}

                    {/* Next ▶ */}
                    {currentPage < totalPages && (
                      <button
                        className="page-btn"
                        onClick={() => setCurrentPage((p) => p + 1)}
                      >
                        ›
                      </button>
                    )}
                  </div>
                )}
              </td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <div className="no-data-found">
          <div className="no-data-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 19a2 2 0 0 1 2-2h14" />
              <path d="M4 5a2 2 0 0 1 2-2h14v18H6a2 2 0 0 1-2-2z" />
            </svg>
          </div>
          <h3>No data found</h3>
          <p>
            {search || Object.values(selectedFilters).some((filter) => filter)
              ? "No records match your search criteria. Try adjusting your filters."
              : "There are no records available at the moment."}
          </p>
          {(search ||
            Object.values(selectedFilters).some((filter) => filter)) && (
            <button
              className="clear-filters-btn"
              onClick={() => {
                setSearch("");
                // Clear all filters
                Object.keys(selectedFilters).forEach((key) => {
                  handleFilterChange(key, null);
                });
              }}
            >
              Clear all filters
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DynamicTable;
